import(/* webpackMode: "eager" */ "/Users/gopal/BlindsCode/blindscommerce/app/guides/measuring/page.tsx");
